//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Table from '../../components/Table/Table.vue'
import TableCellObject from '../../components/Table/TableCellObject.vue'

export default {
  components: {
    Table,
    TableCellObject
  },
  props: {
    riBrigades: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      pagination: {
        rowsPerPage: 0,
        page: 1
      },
      columns: [
        {
          name: 'name',
          label: 'Бригада',
          align: 'left',
          field: 'name',
          sortable: false
        },
        {
          name: 'employees',
          label: 'Состав бригады',
          align: 'left',
          field: 'employees',
          sortable: false,
          columnFormat: 'objects',
          columnObjectType: 'employee',
          columnObjectNameProp: ['fio']
        },
        {
          name: 'riStateName',
          label: 'Статус',
          align: 'left',
          field: 'riStateName',
          sortable: false
        },
        {
          name: 'riStateReason',
          label: 'Причина перехода',
          align: 'left',
          field: 'riStateReason',
          sortable: false
        },
        {
          name: 'number',
          label: 'Номера выезда',
          align: 'left',
          field: 'number',
          sortable: false
        }
      ]
    }
  },
  methods: {
    getTrStyle: function (row) {
      if (row.active === true) {
        return 'background-color: #d3ffd3 !important; border-bottom: solid #e0e0e0 1px;'
      }
    }
  }
}

